import pattern from './pattern'
import coregrainwidth from './core-grain-width'
import preview from './preview'

export default {
  'pattern': pattern,
  'core-grain-width': coregrainwidth,
  'preview': preview
}